import client from "./client";

export const marketingApi = {
  unsubscribe: (token) => client.post("/api/marketing/unsubscribe", { token }),
  getPreferences: () => client.get("/api/marketing/preferences"),
  updatePreferences: (marketingConsent) =>
    client.put("/api/marketing/preferences", { marketing_consent: marketingConsent }),
};
